// A broad starting palette — pick any of these for a product's color
// options, or use "Custom" to enter any hex code (e.g. an exact brand
// color that isn't in this list).
const COLOR_PALETTE = [
  { label: "Black", swatch: "#111827" },
  { label: "White", swatch: "#ffffff" },
  { label: "Grey", swatch: "#9ca3af" },
  { label: "Charcoal", swatch: "#374151" },
  { label: "Navy", swatch: "#1f2a44" },
  { label: "Royal Blue", swatch: "#2563eb" },
  { label: "Sky Blue", swatch: "#38bdf8" },
  { label: "Teal", swatch: "#14b8a6" },
  { label: "Green", swatch: "#16a34a" },
  { label: "Olive", swatch: "#65852c" },
  { label: "Red", swatch: "#dc2626" },
  { label: "Maroon", swatch: "#7f1d1d" },
  { label: "Pink", swatch: "#ec4899" },
  { label: "Purple", swatch: "#7c3aed" },
  { label: "Lavender", swatch: "#c4b5fd" },
  { label: "Orange", swatch: "#f97316" },
  { label: "Yellow", swatch: "#eab308" },
  { label: "Gold", swatch: "#d4af37" },
  { label: "Brown", swatch: "#78350f" },
  { label: "Tan", swatch: "#d2b48c" },
  { label: "Beige", swatch: "#f5f5dc" },
  { label: "Silver", swatch: "#c0c0c0" },
];

export default COLOR_PALETTE;
